<template>
    <v-card-text class="px-0">
        <div class="text-right mt-10 mb-8">
            <v-avatar left color="primary lighten-3">
                <v-img
                    alt="User avatar image"
                    :src="avatarLink"
                    v-if="avatarLink && userSettings.show_avatar"
                ></v-img>
                <v-icon v-else>mdi-account-outline</v-icon>
            </v-avatar>
        </div>

        <div>
            <p class="title font-weight-thin my-0" style="color: #1B1A1A">Hey,</p>
            <p class="title primary--text my-0 font-weight-bold">
                {{ fullname }}
            </p>
        </div>

        <div class="my-8">
            <v-btn
                class="primary--text title pa-6 text-none rounded-lg"
                color="#f0eff6"
                block
                @click="$emit('create')"
            >
                Create new invoice
            </v-btn>
        </div>

        <div>
            <p class="title primary--text font-weight-bold mb-1">
                Overview
            </p>
            <v-sheet
                tile
                color="primary"
                class="pa-4 rounded-lg"
                style="cursor: pointer"
                @click="$emit('show')"
            >
                <v-row>
                    <v-col cols="12">
                        <p class="white--text subtitle-1 my-0">Invoices</p>
                    </v-col>

                    <template v-for="({ number, title }) in invoiceStats">
                        <v-col class="text-center" cols="4" :key="number">
                            <p class="text-h3 white--text my-0">
                                {{ number }}
                            </p>
                            <p class="white--text my-0 text-capitalize subtitle-2 font-weight-thin">
                                {{ title }}
                            </p>
                        </v-col>
                    </template>
                </v-row>
            </v-sheet>
        </div>
    </v-card-text>
</template>

<script>
export default {
    props: {
        invoiceStats: Array,
    },
    computed: {
        fullname() {
            return `${this.$store.state.user.firstname} ${this.$store.state.user.lastname}`;
        },
        avatarLink() {
            return this.$store.state.user.avatar;
        },
        userSettings() {
            if (_.isEmpty(this.$store.state.userSettings)) {
                return {
                    show_name: true,
                    show_avatar: true,
                };
            }

            return this.$store.state.userSettings;
        }
    },

}
</script>

<style>

</style>